/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li5_LabelInputs */

const tr_onbilgi_s11_li5_label = /** @type {(inputs: Onbilgi_S11_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birlikte çalışabilirlik:`)
};

const en_onbilgi_s11_li5_label = /** @type {(inputs: Onbilgi_S11_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interoperability:`)
};

const de_onbilgi_s11_li5_label = /** @type {(inputs: Onbilgi_S11_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interoperabilität:`)
};

const ru_onbilgi_s11_li5_label = /** @type {(inputs: Onbilgi_S11_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместимость:`)
};

/**
* | output |
* | --- |
* | "Interoperability:" |
*
* @param {Onbilgi_S11_Li5_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li5_label = /** @type {((inputs?: Onbilgi_S11_Li5_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li5_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li5_label(inputs)
	if (locale === "de") return de_onbilgi_s11_li5_label(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li5_label(inputs)
	return tr_onbilgi_s11_li5_label(inputs)
});